module.exports = __webpack_public_path__ + "static/frontUserNew/img/door-nav-unconfirmed.48c35acf.png";